import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchActiveRentals } from '../../../Redux/Actions/actions';
import RentalCard from '../../../Components/RentalCard/RentalCard';
import style from './ActiveContracts.module.css';

const ActiveContracts = () => {
  const dispatch = useDispatch();
  const { activeRentals, rentalsLoading, rentalsError } = useSelector(state => state);
  const [filters, setFilters] = useState({
    status: 'active',
    search: '',
    page: 1
  });

  useEffect(() => {
    dispatch(fetchActiveRentals(filters.page, 20, filters.status));
  }, [dispatch, filters.page, filters.status]);

  const handleFilterChange = (key, value) => {
    setFilters(prev => ({
      ...prev,
      [key]: value,
      page: 1 // Reset page when filters change
    }));
  };

  const filteredRentals = activeRentals.filter(rental => {
    if (filters.search) {
      const searchTerm = filters.search.toLowerCase();
      return (
        rental.property?.title?.toLowerCase().includes(searchTerm) ||
        rental.tenants?.some(tenant => 
          tenant.fullName?.toLowerCase().includes(searchTerm)
        )
      );
    }
    return true;
  });

  if (rentalsLoading) {
    return <div className={style.loading}>Cargando contratos...</div>;
  }

  if (rentalsError) {
    return <div className={style.error}>Error: {rentalsError}</div>;
  }

  return (
    <div className={style.container}>
      <h1 className={style.title}>Contratos de Alquiler</h1>
      
      {/* Filtros */}
      <div className={style.filters}>
        <div className={style.filterGroup}>
          <label>Estado:</label>
          <select 
            value={filters.status} 
            onChange={(e) => handleFilterChange('status', e.target.value)}
            className={style.select}
          >
            <option value="active">Activos</option>
            <option value="expired">Vencidos</option>
            <option value="terminated">Terminados</option>
            <option value="all">Todos</option>
          </select>
        </div>
        
        <div className={style.filterGroup}>
          <label>Buscar:</label>
          <input
            type="text"
            placeholder="Propiedad o inquilino..."
            value={filters.search}
            onChange={(e) => handleFilterChange('search', e.target.value)}
            className={style.searchInput}
          />
        </div>
      </div>

      {/* Lista de contratos */}
      <div className={style.contractsList}>
        {filteredRentals.length === 0 ? (
          <div className={style.noData}>
            No se encontraron contratos con los filtros aplicados
          </div>
        ) : (
          filteredRentals.map(rental => (
            <RentalCard key={rental.id} rental={rental} />
          ))
        )}
      </div>

      {/* Estadísticas */}
      <div className={style.stats}>
        <p>Total de contratos: {filteredRentals.length}</p>
      </div>
    </div>
  );
};

export default ActiveContracts;